import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { PopoverController } from "ionic-angular";
import * as _ from "lodash";

interface SelectOption {
  value: string;
  name: string;
  checked: boolean;
}
export class BaseControlValueAccessor<T> implements ControlValueAccessor {
  public disabled = false;
  @Output()
  valueChanged: EventEmitter<any> = new EventEmitter<any>();

  public onChange(newVal: T) {}

  public onTouched(_?: any) {}

  public value: T;

  public writeValue(obj: T): void {
    this.value = obj;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}

@Component({
  selector: "multi-select-dropdown",
  templateUrl: "multi-select-dropdown.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MultiSelectDropdownComponent),
    },
  ],
})
export class MultiSelectDropdownComponent
  extends BaseControlValueAccessor<string[]>
  implements OnInit
{
  @ViewChild("itemContainer") itemContainer: ElementRef;

  @Input() canChangeItem: boolean = true;
  @Input() emptyMsg: string = "No items found.";
  @Input() items: SelectOption[];
  @Input() nameHeader: string = "name";
  @Input() idHeader: string = "id";
  @Input() placeholder: string;
  @Input() id: string;
  @Input() IsshowSelectAll: boolean = false;
  @Input() verfiyonchange: boolean = false;
  itemsOptions: any;
  loadingItems: boolean = true;
  selectedItemArray: any;
  selectedItemIds: any;
  selectedItems: any;

  constructor(private popover: PopoverController) {
    super();
  }

  public writeValue(obj: string[]): void {
    super.writeValue(obj);
    if (!_.isEmpty(this.value)) {
      this.selectedItemArray = [];
      this.itemsOptions.map((item) => {
        if (obj.includes(item.value[this.idHeader])) {
          item.checked = true;
          this.selectedItemArray.push(item.name);
        }
      });
      this.selectedItems = this.selectedItemArray.join();
    }
  }

  ngOnInit(): void {
    this.checkItemsData();
  }

  checkItemsData() {
    if (!_.isEmpty(this.items)) {
      this.makeItemsOptions();
    } else {
      this.canChangeItem = false;
    }
    this.loadingItems = false;
  }

  makeItemsOptions() {
    this.itemsOptions = this.items.map((item) => {
      return {
        name: item.name,
        value: item,
        checked: false,
      };
    });
  }

  setNewItem() {
    this.selectedItemArray = [];
    this.selectedItemIds = [];
    this.itemsOptions.map((item) => {
      if (item.checked) {
        this.selectedItemArray.push(item.name);
        this.selectedItemIds.push(item.value[this.idHeader]);
      }
    });
    this.selectedItems = this.selectedItemArray.join();
    this.emitValueChanged();
  }

  selectItem(event) {
    const searchable = true;
    const searchPlaceholder = this.placeholder;
    const emptyMessage = this.emptyMsg;
    const containerWidth = this.itemContainer.nativeElement.offsetWidth;
    const showSelectAll = this.IsshowSelectAll;
    const verfiyonchangeitem = this.verfiyonchange;
    let options = this.itemsOptions.map((a) => ({ ...a }));
    const popover = this.popover.create("SelectMultiSelectDropdownPage", {
      options,
      searchable,
      searchPlaceholder,
      emptyMessage,
      isMultiSelect: true,
      containerWidth,
      showSelectAll,
      verfiyonchangeitem,
    });
    popover.onDidDismiss((data) => {
      if (data) {
        this.itemsOptions = data.options;
        this.setNewItem();
      }
    });

    const containerHeight = this.itemContainer.nativeElement.offsetHeight;
    const initialTopValue = event.target.getBoundingClientRect().top;

    let left = event.target.getBoundingClientRect().left;

    if (window.navigator.userAgent.indexOf("iPad") !== -1) {
      left += containerWidth / 2;
    }

    const ev = {
      target: {
        getBoundingClientRect: () => {
          return {
            top: initialTopValue + containerHeight,
            left,
          };
        },
      },
    };

    popover.present({ ev });
  }

  public emitValueChanged() {
    this.onChange(this.selectedItemIds);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/multi-select-dropdown/multi-select-dropdown.ts